import * as S from "./UserSideMenuItem.style";
import { useNavigate } from "react-router";
import { ReactComponent as IconArrow } from "@/styles/assets/svg/icon_arrow_rt.svg";

interface UserSideMenuItemProps {
  item: any;
}

export const UserSideMenuItem = ({ item }: UserSideMenuItemProps) => {
  const navigate = useNavigate();
  return (
    <S.UserSideMenuItem
      $icon={item.icon ? true : false}
      onClick={
        item.path ? () => navigate(item.path) : item.onClick && item.onClick
      }
    >
      {item.icon && item.icon}
      <S.UserSideMenuTitle>{item.title}</S.UserSideMenuTitle>
      <IconArrow />
    </S.UserSideMenuItem>
  );
};
